import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Alert from "react-bootstrap/Alert";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
import "./AssessmentStatus.css";

function SencoResultsStatus({
  allClassesAssessments,
  teachers,
  schoolid,
  classIds,
  name,
  teacherid,
  academicYear,
  gradeLevel // New prop to specify grade level (1 or 2)
}) {
  // Define the assessment order
  const assessmentOrder = useMemo(
    () => ({
      baseline: 1,
      midpoint: 2,
      "end of year": 3,
    }),
    []
  );

  // Flatten, deduplicate, and sort assessments based on `assessmentid`
  const uniqueAssessments = useMemo(() => {
    // Log the data we're working with
    console.log(`Processing grade level ${gradeLevel} assessments:`, allClassesAssessments);
    
    if (!allClassesAssessments || !Array.isArray(allClassesAssessments) || allClassesAssessments.length === 0) {
      return [];
    }

    // Helper function to determine the sort key
    const getSortKey = (name) => {
      if (!name) return 4;
      
      name = name.toLowerCase();
      if (name.includes("baseline") || name.includes("autumn"))
        return assessmentOrder["baseline"];
      if (name.includes("midpoint") || name.includes("spring"))
        return assessmentOrder["midpoint"];
      if (name.includes("end of year") || name.includes("summer"))
        return assessmentOrder["end of year"];
      return 4; // Default sort key for unrecognized assessments
    };

    // Reduce assessments to a unique set
    const flattened = Object.values(
      allClassesAssessments.reduce((acc, classAssessment) => {
        if (!classAssessment || !classAssessment.assessments) {
          return acc;
        }
        
        Object.entries(classAssessment.assessments).forEach(([assessmentId, assessment]) => {
          // Skip if already processed or not matching the grade level
          if (acc[assessmentId]) return;
          
          // Check if the assessment matches the requested grade level
          const isGradeLevel1 = assessment && assessment.grade_level1 === true;
          const isGradeLevel2 = assessment && assessment.grade_level2 === true;
          const isGradeLevel3 = assessment && assessment.grade_level3 === true;
          
          // Only include assessments matching the specified grade level
          if ((gradeLevel === 1 && isGradeLevel1) || (gradeLevel === 2 && isGradeLevel2) || (gradeLevel === 3 && isGradeLevel3)) {
            acc[assessmentId] = {
              ...assessment,
              id: assessmentId,
            };
          }
        });
        
        return acc;
      }, {})
    );

    console.log(`Flattened ${gradeLevel} assessments:`, flattened);

    // Filter and sort the unique assessments
    return flattened
      .filter((assessment) => {
        if (!assessment || !assessment.name) return false;
        
        // Check if it's a screener assessment
        const name = assessment.name.toLowerCase();
        return (
          name.includes("baseline") ||
          name.includes("midpoint") ||
          name.includes("end of year") 
          // || name.includes("screener")
        );
      })
      .sort((a, b) => getSortKey(a.name) - getSortKey(b.name));
  }, [allClassesAssessments, assessmentOrder, gradeLevel]);

  // Helper function to get the image name for an assessment
  const getIconFileName = (assessmentName) => {
    if (!assessmentName) return "autumn"; // Default
    
    let name = assessmentName.toLowerCase();

    // Logic for season-based assessments
    if (
      name.includes("baseline") ||
      name.includes("point 1") ||
      name.includes("autumn")
    ) {
      return "autumn";
    } else if (
      name.includes("midpoint") ||
      name.includes("point 2") ||
      name.includes("spring")
    ) {
      return "spring";
    } else if (
      name.includes("end of year") ||
      name.includes("point 3") ||
      name.includes("summer")
    ) {
      return "summer";
    }

    // For other task-based assessments
    const words = name.split(" ");
    return words.slice(0, 2).join(""); // Combine first two words for image name
  };

  const navigate = useNavigate();

  // Navigate to results when an assessment is clicked
  const toSencoAssessmentResults = (assessment) => {
    navigate("/senco/studentsresults", {
      state: {
        assessment,
        assessmentId: assessment.id,
        teachers,
        schoolid,
        classIds,
        name,
        allClassesAssessments,
        teacherid,
        academicYear,
      },
    });
  };

  return (
    <Row>
      {!uniqueAssessments || uniqueAssessments.length === 0 ? (
        <Col>
          <Alert variant="info" className="text-center">
            <FontAwesomeIcon
              icon={faExclamationCircle}
              size="3x"
              className="mb-3"
            />
            <h4>No Results Available</h4>
            <p>
              Once your students begin screening, the results will start to
              populate here.
            </p>
          </Alert>
        </Col>
      ) : (
        uniqueAssessments.map((assessment, index) => (
          <Col className="col-4" key={index}>
            <div
              className="assessment-card"
              onClick={() => toSencoAssessmentResults(assessment)}
            >
              <div className="card-image">
                <img
                  src={`/assets/imgs/${getIconFileName(
                    assessment?.name
                  )}-icon.png`}
                  className="season-assessment-icon"
                  alt={assessment?.name || "Assessment"}
                />
              </div>
              <div className="card-content">
                <span>{assessment?.name?.replace(" Instance", "") || "Assessment"}</span>
              </div>
            </div>
          </Col>
        ))
      )}
    </Row>
  );
}

export default SencoResultsStatus;

// import React, { useMemo } from "react";
// import { useNavigate } from "react-router-dom";
// import Row from "react-bootstrap/Row";
// import Col from "react-bootstrap/Col";
// import Alert from "react-bootstrap/Alert";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
// import "./AssessmentStatus.css";

// function SencoResultsStatus({
//   allClassesAssessments,
//   teachers,
//   schoolid,
//   classIds,
//   name,
//   teacherid,
//   YEAR_RANGES,
//   selectedYear
// }) {
//   // Define the assessment order
//   const assessmentOrder = useMemo(
//     () => ({
//       baseline: 1,
//       midpoint: 2,
//       "end of year": 3,
//     }),
//     []
//   );
//   console.log(allClassesAssessments, "allClassesAssessments");
//   // Flatten, deduplicate, and sort assessments based on `assessmentid`
//   const uniqueAssessments = useMemo(() => {
//     // Helper function to determine the sort key
//     const getSortKey = (name) => {
//       name = name.toLowerCase();
//       if (name.includes("baseline") || name.includes("autumn"))
//         return assessmentOrder["baseline"];
//       if (name.includes("midpoint") || name.includes("spring"))
//         return assessmentOrder["midpoint"];
//       if (name.includes("end of year") || name.includes("summer"))
//         return assessmentOrder["end of year"];
//       return 4; // Default sort key for unrecognized assessments
//     };

//     // Reduce assessments to a unique set
//     const flattened = Object.values(
//       allClassesAssessments.reduce((acc, classAssessments) => {
//         Object.keys(classAssessments.assessments).forEach((assessmentId) => {
//           if (!acc[assessmentId]) {
//             acc[assessmentId] = {
//               ...classAssessments.assessments[assessmentId],
//               id: assessmentId, // Store assessmentId directly
//             };
//           }
//         });
//         return acc;
//       }, {})
//     );

//     // Filter and sort the unique assessments
//     return flattened
//       .filter((assessment) => {
//         const name = assessment.name.toLowerCase();
//         return (
//           name.includes("baseline") ||
//           name.includes("midpoint") ||
//           name.includes("end of year")
//         );
//       })
//       .sort((a, b) => getSortKey(a.name) - getSortKey(b.name));
//   }, [allClassesAssessments, assessmentOrder]);

//   // Helper function to get the image name for an assessment
//   const getIconFileName = (assessmentName) => {
//     let name = assessmentName.toLowerCase();

//     // Logic for season-based assessments
//     if (
//       name.includes("baseline") ||
//       name.includes("point 1") ||
//       name.includes("autumn")
//     ) {
//       return "autumn";
//     } else if (
//       name.includes("midpoint") ||
//       name.includes("point 2") ||
//       name.includes("spring")
//     ) {
//       return "spring";
//     } else if (
//       name.includes("end of year") ||
//       name.includes("point 3") ||
//       name.includes("summer")
//     ) {
//       return "summer";
//     }

//     // For other task-based assessments
//     const words = name.split(" ");
//     return words.slice(0, 2).join(""); // Combine first two words for image name
//   };

//   const navigate = useNavigate();

//   // Navigate to results when an assessment is clicked
//   const toSencoAssessmentResults = (assessment) => {
//     navigate("/senco/studentsresults", {
//       state: {
//         assessment,
//         assessmentId: assessment.id,
//         teachers,
//         schoolid,
//         classIds,
//         name,
//         allClassesAssessments,
//         teacherid,
//         YEAR_RANGES,
//         selectedYear,
//       },
//     });
//   };

//   return (
//     <Row>
//       {uniqueAssessments.length === 0 ? (
//         <Col>
//           <Alert variant="info" className="text-center">
//             <FontAwesomeIcon
//               icon={faExclamationCircle}
//               size="3x"
//               className="mb-3"
//             />
//             <h4>No Results Available</h4>
//             <p>
//               Once your students begin screening, the results will start to
//               populate here.
//             </p>
//           </Alert>
//         </Col>
//       ) : (
//         uniqueAssessments.map((assessment, index) => (
//           <Col className="col-4" key={index}>
//             <div
//               className="assessment-card"
//               onClick={() => toSencoAssessmentResults(assessment)}
//             >
//               <div className="card-image">
//                 <img
//                   src={`/assets/imgs/${getIconFileName(
//                     assessment.name
//                   )}-icon.png`}
//                   className="season-assessment-icon"
//                   alt={assessment.name}
//                 />
//               </div>
//               <div className="card-content">
//                 <span>{assessment.name.replace(" Instance", "")}</span>
//               </div>
//             </div>
//           </Col>
//         ))
//       )}
//     </Row>
//   );
// }

// export default SencoResultsStatus;
